export function storeColoringActions(drawingId, actions) {
    return new Promise((resolve, reject) => {
        try {
            localStorage.setItem('COLORING_ACTIONS_' + drawingId.toUpperCase(), JSON.stringify(actions))
            resolve()
        } catch (e) {
            reject(e)
        }
    })
}

export function getColoringActions(drawingId) {
    try {
        const actionsStr = localStorage.getItem('COLORING_ACTIONS_' + drawingId.toUpperCase())
        return JSON.parse(actionsStr)
    } catch (e) {
        console.error(e)
        return []
    }
}

export function removeColoringActions(drawingId) {
    try {
        localStorage.removeItem('COLORING_ACTIONS_' + drawingId.toUpperCase())
    } catch (e) {
        console.error(e)
        return []
    }
}